export default "__VITE_ASSET__rHToDIjs__"